export default __webpack_public_path__ + "static/media/advicegradissuegfx-09.5c226aee.png";